/*
 * Copyright © 2025 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {updateState} from '@angular-architects/ngrx-toolkit';
import {computed} from '@angular/core';
import type {RestPaginated} from '@dv/shared/code';
import {signalStoreFeature, withComputed, withMethods, withState} from '@ngrx/signals';
import type {ItemsPerPageOptions} from './items-per-page';
import type {PaginationState} from './pagination.shared';
import {defaultPaginationState} from './pagination.shared';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function withPaginationFunctionality() {
    return signalStoreFeature(
        withState<PaginationState>(defaultPaginationState()),
        withComputed(store => ({
            restParams: computed<RestPaginated>(() => ({
                top: store.itemsPerPage(),
                skip: store.itemsPerPage() * (store.currentPage() - 1),
            }), {
                equal: (a, b) => {
                    return a.top === b.top && a.skip === b.skip;
                },
            }),
        })),
        withMethods(store => ({
            setItemsPerPage(itemsPerPage: ItemsPerPageOptions): void {
                updateState(store, '[Pagination] setItemsPerPage', {itemsPerPage});
            },
            setCurrentPage(currentPage: number): void {
                updateState(store, '[Pagination] setCurrentPage', {currentPage});
            },
            _setItemsCount(itemsCount: number): void {
                updateState(store, '[Pagination] setItemsCount', {itemsCount});
            },
        })),
    );
}
